export enum FeatureFlag {
  RedeemablesV2 = "dines.web.redeemables-v2-enabled",
  VoucherCodes = "dines.api.voucher-codes-enabled",
  Reports = "dines.api.reports-enabled",
  ReportingMaintenance = "dines.web.reporting-maintenance-enabled",
}
